module.exports = {"mobile":"480","tablet":"768","tabletL":"1024","desktop":"1280","wide":"1440","is":{"webkit":"(-webkit-min-device-pixel-ratio: 0)","retina":"(-webkit-min-device-pixel-ratio: 2), (min--moz-device-pixel-ratio: 2), (-o-min-device-pixel-ratio: 2/1), (min-device-pixel-ratio: 2), (min-resolution: 192dpi), (min-resolution: 2dppx)"}}


//////////////////
// WEBPACK FOOTER
// ./src/css/media-queries.json
// module id = 299
// module chunks = 1